"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../controllers/BaseController");
var DlgPwdChangeAdmCtl = /** @class */ (function (_super) {
    __extends(DlgPwdChangeAdmCtl, _super);
    function DlgPwdChangeAdmCtl() {
        return _super.call(this, true) || this;
    }
    DlgPwdChangeAdmCtl.prototype.ResetData = function () {
        this.DATA = {
            onYes: null,
            newPass: "",
            repeatNewPass: "",
            visible: false
        };
    };
    DlgPwdChangeAdmCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgPwdChangeAdmCtl.prototype.clearFields = function () {
        this.ResetData();
        return this;
    };
    DlgPwdChangeAdmCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgPwdChangeAdmCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgPwdChangeAdmCtl.prototype.SetOnYesClick = function (callback) {
        this.DATA.onYes = callback;
        this.Update();
        return this;
    };
    return DlgPwdChangeAdmCtl;
}(BaseController_1.BaseController));
exports.DlgPwdChangeAdmCtl = DlgPwdChangeAdmCtl;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ctl/DlgPwdChangeAdmCtl.ts
// module id = 887
// module chunks = 0